<template>
    <div class="duenos-y-arrendadores color-morado">

        <v-container fluid class="neutral-towers-bg">
            <v-row>
                <v-col class="text-center">
                    <v-img src="../assets/img/neutral-towers-logo.png" height="300px" width="600px" contain position="center center" class="mx-auto"></v-img>
                </v-col>
            </v-row>
        </v-container>
        <v-container>
            <v-row class="px-3" >
                <v-col class="pa-6 pa-sm-16 ">

                    <div class="mx-auto" style="max-width: 600px;">
                        <!-- <span class="titulos-size bold d-block mb-3" >{{arrendadores.titulo}} </span> -->
                        <!-- <span class="subtitulo d-block mb-3" >
                            Si eres dueño de un terreno, edificio o torre nos gustaría platicar contigo acerca de la manera en que podemos ayudarte a maximizar tus activos.
                        </span>

                        <span class="subtitulo d-block mb-3" >
                            Registra tu terreno: si te gustaría registrar tu terreno como un sitio potencial de internet inalámbrico, por favor llena el siguiente formulario.
                        </span>

                        <span class="subtitulo d-block mb-3" >
                            Registra tu edificio: si te gustaría registrar tu edificio como un sitio potencial de internet inalámbrico, por favor llena el siguiente formulario.
                        </span> -->
                        <span class="subtitulo d-block mb-3" v-html="arrendadores.descripcion"></span>

                        <hr class=" mt-6" style=" color:#FFF;">
                    </div>
                    

                </v-col>
            </v-row>
            <v-row>
                <v-col>
                    

                        <v-form lazy-validation v-model="valid" ref="form">
                            <v-container class="pa-8 pa-md-0">
                                <v-row id="contactForm" justify-md="center">
                                    <v-col cols="12" md="6" class="py-0">
                                        <v-select :items="items"  :label="rolLabel"  outlined v-model="form.rol" :rules="emptyRule" required ></v-select>
                                    </v-col>
                                    
                                    <v-col cols="12" md="6" class="py-0">
                                        <v-text-field  :label="emailLabel" outlined v-model="form.correo" :rules="emailRule" required></v-text-field>
                                    </v-col>
                                    <v-col cols="12" md="6" class="py-0">
                                        <v-text-field  :label="nameLabel" outlined  v-model="form.nombre" :rules="emptyRule" required></v-text-field>
                                    </v-col>
                                    <!-- <v-col cols="12" md="6" class="py-0">
                                        <v-text-field  label="Teléfono" outlined ></v-text-field>
                                    </v-col>
                                    <v-col cols="12" md="6" class="py-0">
                                        <v-text-field  label="Ciudad" outlined ></v-text-field>
                                    </v-col>
                                    <v-col cols="12" md="6" class="py-0">
                                        <v-text-field  label="Estado" outlined ></v-text-field>
                                    </v-col>
                                    <v-col cols="12" md="6" class="px-5 py-0"  >
                                        <span class="titulos-size bold">¿Es usted dueño de la propiedad?</span>
                                        <v-radio-group   row>
                                            <v-radio label="Si" value="radio-1" ></v-radio>
                                            <v-radio label="No" value="radio-2" ></v-radio>
                                        </v-radio-group>
                                    </v-col>
                                    <v-col cols="12" md="6" class="px-5 py-0" >
                                        <span class="titulos-size bold">¿Se encuentra dado de alta en el SAT?</span>
                                        <v-radio-group   row>
                                            <v-radio label="Si" value="radio-1" ></v-radio>
                                            <v-radio label="No" value="radio-2" ></v-radio>
                                        </v-radio-group>
                                    </v-col>
                                    <v-col cols="12" md="6" class="px-5 py-0" >
                                        <v-select :items="items2"  label="¿Es usted propietario o arrendador?"  outlined ></v-select>
                                    </v-col>

                                    <v-col cols="12" md="6" class="py-0">
                                        <v-text-field  label="RFC" outlined ></v-text-field>
                                    </v-col> -->


                                    <v-col cols="12" md="6" class="py-0">  
                                        <v-text-field  :label="companyLabel" outlined :rules="emptyRule" required></v-text-field>
                                    </v-col>
                                    
                                    <v-col cols="12" md="12" class="py-0">  
                                        <v-textarea outlined name="input-7-4" :label="messageLabel" v-model="form.mensaje" required :rules="emptyRule"></v-textarea>
                                    </v-col>



                                    <v-col cols="auto" style="color:#5C27B2;" class="text-center py-0">
                                        <v-checkbox color="#5C27B2"  hide-details="true" class="py-0 my-0" v-model="checkbox"  required :rules="emptyRule">
                                            <template v-slot:label class="py-0" >
                                                <div v-if="locale == 'en'" style="color:#5C27B2; padding:0;">
                                                    I agree to the 
                                                    <router-link to="/terminos-y-condiciones"  style="color:blue; text-decoration:none;">Terms</router-link> & <router-link to="/terminos-y-condiciones" style="color:blue; text-decoration:none;">conditions</router-link>
                                                </div>
                                                <div v-else style="color:#5C27B2; padding:0;">
                                                    Confirmo que he leído los
                                                    <router-link to="/terminos-y-condiciones"  style="color:blue; text-decoration:none;">Términos</router-link> y <router-link to="/terminos-y-condiciones" style="color:blue; text-decoration:none;">condiciones</router-link>
                                                </div>
                                            </template>
                                        </v-checkbox>
                                    </v-col>
                                    
                                </v-row>

                                
                                <v-row justify="center">
                                    <v-col class="text-center py-10">
                                        <v-btn outlined  :disabled="!valid" x-large color="#5C27B2" @click="validateFields">
                                            <template v-if="locale == 'en'">
                                                Send
                                            </template>
                                            <template v-else>
                                                Enviar
                                            </template>
                                        </v-btn>
                                    </v-col>
                                </v-row>
                            </v-container>
                        </v-form>
                    
                    <v-snackbar v-model="snackbar" >
                        Información enviada

                        <template v-slot:action="{ attrs }">
                            <v-btn
                            color="pink"
                            text
                            v-bind="attrs"
                            @click="snackbar = false"
                            >
                            Close
                            </v-btn>
                        </template>
                        </v-snackbar>
                </v-col>
            </v-row>

        </v-container>
    </div>
</template>
<script>

export default {
    
    data(){
        return{
            items:['Propietarios de terrenos', 'Propietarios de torres', 'Arrendadores'],
            items2:['Residencial', 'Comercial'],
            arrendadores:{},

            snackbar:false,
            checkbox:false,
            valid:true,
            form:{
                rol:null,
                nombre:'',
                correo:'',
                mensaje:''
            },
            emptyRule:[
                validation => !!validation || 'El Campo  es requerido',
            ],
            emailRule: [
                validation => !!validation || 'Correo es requerido',
                
                validation =>  /.+@.+\..+/.test(validation) || 'El formato no es correcto',
            ],
        }
    },
    mounted: function(){
        if(this.locale == 'en'){
            this.items = ['Building owners','Tower owners','Landlords']
            fetch('https://nncms.actstudio.xyz/api/singletons/get/DuenosyArrendadores?token=8cf7ca41761951fdde0c1e2cfda401',{
                method: "post",
                headers: { "Content-Type": "application/json" },
                body: JSON.stringify({
                    lang: 'en' // return normalized language fields (fieldA_de => fieldA)
                }),  
            })
            .then(data => data.json())
            .then(data => this.arrendadores = data);   
        }else{
            fetch('https://nncms.actstudio.xyz/api/singletons/get/DuenosyArrendadores?token=8cf7ca41761951fdde0c1e2cfda401',{
                method: "post",
                headers: { "Content-Type": "application/json" },
                body: JSON.stringify({
                }),  
            })
            .then(data => data.json())
            .then(data => this.arrendadores = data);
        }

        this.$gtag.pageview({ page_path: '/duenos-y-arrendadores', page_title: 'Dueños de activos y arrendadores' })
    },
    computed: {
        locale: function () {
            return this.$i18n.locale;
        },
        rolLabel: function () {
            if(this.locale == 'en'){
                return 'Are you an owner or a landlord?'
            }else{
                return '¿Es usted propietario o arrendador?'
            }
        },
        emailLabel: function () {
            if(this.locale == 'en'){
                return 'Email'
            }else{
                return 'Correo'
            }
        },
        nameLabel: function() {
            if(this.locale == 'en'){
                return 'Name'
            }else{
                return 'Nombre'
            }
        },
        companyLabel: function () {
            if(this.locale == 'en'){
                return 'Company'
            }else{
                return 'Empresa'
            }
        },
        messageLabel: function () {
            if(this.locale == 'en'){
                return 'Message'
            }else{
                return 'Mensaje'
            }
        }
    },
    watch: {
        locale: function () {
            if(this.locale == 'en'){
                this.items = ['Building owners','Tower owners','Landlords']
            fetch('https://nncms.actstudio.xyz/api/singletons/get/DuenosyArrendadores?token=8cf7ca41761951fdde0c1e2cfda401',{
                method: "post",
                headers: { "Content-Type": "application/json" },
                body: JSON.stringify({
                    lang: 'en' // return normalized language fields (fieldA_de => fieldA)
                }),  
            })
            .then(data => data.json())
            .then(data => this.arrendadores = data);   
        }else{
            this.items = ['Propietarios de terrenos', 'Propietarios de torres', 'Arrendadores']
            fetch('https://nncms.actstudio.xyz/api/singletons/get/DuenosyArrendadores?token=8cf7ca41761951fdde0c1e2cfda401',{
                method: "post",
                headers: { "Content-Type": "application/json" },
                body: JSON.stringify({
                }),  
            })
            .then(data => data.json())
            .then(data => this.arrendadores = data);
        }
        }
    },
    methods:{
      enviarForm:function(){
         
            fetch('https://nncms.actstudio.xyz/api/forms/submit/DuenosArrendadores?token=8cf7ca41761951fdde0c1e2cfda401', {
            method: 'post',
            headers: { 'Content-Type': 'application/json' },
            body: JSON.stringify({
                form: this.form
            })
        })
        .then(entry => entry.json())
        .then(()=> this.snackbar = true)
        .then(()=> this.$refs.form.reset())
        },
        limpiarForm:function(){
            this.form.rol = '';
            this.form.nombre = '';
            this.form.correo = '';
            this.form.mensaje = '';

        },
        validateFields () {
            var result = this.$refs.form.validate();
            
            if(result){
                this.enviarForm();
                
            }
        },
        
    }

}
</script>